var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"mb-4"},[_c('h2',[_vm._v("Orders")])]),_c('pre',[_vm._v(_vm._s(_vm.orders))])])
}
var staticRenderFns = []

export { render, staticRenderFns }